import { render, staticRenderFns } from "./CdBasketIcon.vue?vue&type=template&id=17be8642&scoped=true&"
var script = {}
import style0 from "./CdBasketIcon.vue?vue&type=style&index=0&id=17be8642&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17be8642",
  null
  
)

export default component.exports